import { ABTestNameEnum, ABTestVariationEnum } from '@inter-ikea-kompis/enums';
import KioskABTestVariation from './KioskABTestVariation.js';
const KOMPIS_AB_TEST_KEY = 'kompisABTest';
/**
 * A/B test variation utility.
 */
export default class ABTestUtility {
    /**
     * Returns AB test name and variation if there is an active test available in DEXF settings.
     * If no test is enabled it will return null.
     *
     * If the AB test is ran exclusively on kiosk, supply the kioskLongTermId for a variation generation more suitable for that use case.
     */
    static initializeABTests(settings, kioskLongTermId) {
        const { abTest } = settings.kompis.localization;
        if (!(abTest && abTest in ABTestNameEnum)) {
            return null;
        }
        const name = abTest;
        const variation = ABTestUtility.getVariation(name, kioskLongTermId);
        return { name, variation };
    }
    static getVariation(abTestId, kioskLongTermId) {
        if (kioskLongTermId) {
            return KioskABTestVariation.getVariation(kioskLongTermId);
        }
        return this.getLocalStorageTestVariation(abTestId) ?? this.setNewTestVariation(abTestId);
    }
    static getLocalStorageTestVariation(abTestId) {
        const localStorageABTest = localStorage.getItem(KOMPIS_AB_TEST_KEY);
        const localStorageABTestKeys = localStorageABTest && JSON.parse(localStorageABTest);
        if (localStorageABTestKeys) {
            const currentABTest = localStorageABTestKeys[abTestId];
            if (currentABTest && currentABTest in ABTestVariationEnum) {
                return currentABTest;
            }
        }
        return null;
    }
    static setNewTestVariation(abTestId) {
        const variation = Math.random() < 0.5 ? ABTestVariationEnum.A : ABTestVariationEnum.B;
        const localStorageABTest = localStorage.getItem(KOMPIS_AB_TEST_KEY);
        const value = {
            ...(localStorageABTest && JSON.parse(localStorageABTest)),
            [abTestId]: variation
        };
        localStorage.setItem(KOMPIS_AB_TEST_KEY, JSON.stringify(value));
        return variation;
    }
}
//# sourceMappingURL=ABTestUtility.js.map